import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom'
import ArrowRight2 from '../assets/images/arrow-right-2.svg'

import { ASSETS_URL } from "../api/constants";

const CareerCompanyFeatures = ({career_section}) => {

  const section2 = career_section?.section_2
  const section3Cards = career_section?.section_3?.cards || []


  return (
    <section className="company-features-section common-padding">
      <Container>
        <div className="common-header text-center">
          <h2>{section2?.title}</h2>
          <p>{section2?.subtitle}</p>
        </div>
        <Row>
          {section3Cards.map((card, index) => (
            <Col lg={4} md={4} sm={12} key={index} className="mb-4 mb-md-0">
              <div className="feature-card">
                <div className="feature-image">
                  <img src={`${ASSETS_URL}${card.image}`} alt={card.title} />
                </div>
                <div className="feature-content">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="text-center bttn-group">
          <Link
            to={section2?.btn_link || '/'}
            className="custom-bttn style-3 ani-1"
          >
            {section2?.btn_name || 'Explore Life at Real Estate'}
            <img src={ArrowRight2} alt="Arrow Right" />
          </Link>
        </div>
      </Container>
    </section>
  )
}

export default CareerCompanyFeatures